var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77778 5.71429L8.52845 9.86572L8.53 9.86714C9.05733 10.2221 9.321 10.4 9.61033 10.4686C9.8659 10.5293 10.1341 10.5293 10.3897 10.4686C10.679 10.4 10.9434 10.2221 11.4723 9.86572C11.4723 9.86572 14.5189 6.86143 16.2222 5.71429M3 12.7143V7.28572C3 6.48572 3 6.08572 3.16956 5.78C3.31889 5.51072 3.55611 5.29286 3.84933 5.15572C4.18222 5 4.61778 5 5.48889 5H14.5111C15.3822 5 15.8178 5 16.1499 5.15572C16.4431 5.29286 16.6811 5.51072 16.8304 5.78C17 6.085 17 6.485 17 7.28357V12.7171C17 13.5157 17 13.9143 16.8304 14.22C16.6811 14.4889 16.4429 14.7074 16.1499 14.8443C15.8178 15 15.383 15 14.5134 15H5.48656C4.617 15 4.18145 15 3.84933 14.8443C3.55665 14.7073 3.31869 14.4888 3.16956 14.22C3 13.9143 3 13.5143 3 12.7143Z",
    stroke: "#264742",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d6806b635af67895d38eb44d1a965e97.svg";
export { ForwardRef as ReactComponent };